import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'

export const TriggerComponent = ({ onClick }) => (
  <BusyButton bsStyle={'primary'} text="Add to favorite" icon="heart" onClick={onClick} />
)
